(function () {
  function initCarousel(root) {
    if (!root || root.dataset.wyReady === 'true') return;
    var items = root.querySelectorAll('[data-wy-slide]');
    if (!items.length) return;
    root.dataset.wyReady = 'true';
    var interval = parseInt(root.dataset.interval || '4000', 10);
    var index = 0;
    var timer;

    function show(next) {
      index = (next + items.length) % items.length;
      items.forEach(function (item, i) {
        item.classList.toggle('is-active', i === index);
        item.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
    }

    function start() {
      if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      stop();
      timer = window.setInterval(function () { show(index + 1); }, interval);
    }
    function stop() { if (timer) window.clearInterval(timer); }

    show(0);
    start();
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
  }

  function initMobileNav() {
    document.querySelectorAll('[data-wy-nav-toggle]').forEach(function (toggle) {
      if (toggle.dataset.wyReady === 'true') return;
      toggle.dataset.wyReady = 'true';
      var id = toggle.getAttribute('aria-controls');
      var drawer = document.getElementById(id);
      if (!drawer) return;
      function close() {
        toggle.setAttribute('aria-expanded', 'false');
        drawer.classList.remove('is-open');
        document.documentElement.classList.remove('wy-no-scroll');
      }
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        if (open) close();
        else {
          toggle.setAttribute('aria-expanded', 'true');
          drawer.classList.add('is-open');
          document.documentElement.classList.add('wy-no-scroll');
        }
      });
      drawer.querySelectorAll('[data-wy-nav-close]').forEach(function (button) { button.addEventListener('click', close); });
      document.addEventListener('keydown', function (event) { if (event.key === 'Escape') close(); });
    });
  }

  function initProductForms() {
    document.querySelectorAll('.wy-product-form').forEach(function (form) {
      if (form.dataset.wyReady === 'true') return;
      form.dataset.wyReady = 'true';
      var variantSelect = form.querySelector('[name="id"]');
      var optionSelects = form.querySelectorAll('[data-option-index]');
      var productRoot = form.closest('[data-wy-product]');
      var price = productRoot && productRoot.querySelector('[data-wy-price]');
      var button = form.querySelector('[data-wy-atc]');
      var variantsScript = productRoot && productRoot.querySelector('[data-wy-variants]');
      var variants = [];
      try { variants = JSON.parse(variantsScript ? variantsScript.textContent : '[]'); } catch (e) {}

      function sync() {
        if (!optionSelects.length) return;
        var values = Array.from(optionSelects).map(function (select) { return select.value; });
        var variant = variants.find(function (v) {
          return values.every(function (value, i) { return v.options[i] === value; });
        });
        if (!variant) return;
        variantSelect.value = variant.id;
        if (price) {
          price.innerHTML = (variant.compare_at_price && variant.compare_at_price > variant.price ? '<s>' + window.Wildyoung.money(variant.compare_at_price) + '</s> ' : '') + '<strong>' + window.Wildyoung.money(variant.price) + '</strong>';
        }
        if (button) {
          button.disabled = !variant.available;
          button.textContent = variant.available ? button.dataset.availableText : button.dataset.soldoutText;
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      optionSelects.forEach(function (select) { select.addEventListener('change', sync); });
      sync();
    });
  }

  function initSort() {
    document.querySelectorAll('[data-wy-sort]').forEach(function (select) {
      if (select.dataset.wyReady === 'true') return;
      select.dataset.wyReady = 'true';
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        if (select.value) url.searchParams.set('sort_by', select.value);
        else url.searchParams.delete('sort_by');
        window.location.assign(url.toString());
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-wy-carousel]').forEach(initCarousel);
    initMobileNav();
    initProductForms();
    initSort();
  }

  window.Wildyoung = window.Wildyoung || {};
  window.Wildyoung.money = function (cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', { style: 'currency', currency: window.Wildyoung.currency || 'EUR' }).format(cents / 100); }
    catch (e) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }
  };
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
